import { render, staticRenderFns } from "./Compress.vue?vue&type=template&id=6512cd77&scoped=true&"
import script from "./Compress.vue?vue&type=script&lang=js&"
export * from "./Compress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512cd77",
  null
  
)

export default component.exports